import { render, staticRenderFns } from "./centerTabs.vue?vue&type=template&id=ef92941a&scoped=true&"
import script from "./centerTabs.vue?vue&type=script&lang=js&"
export * from "./centerTabs.vue?vue&type=script&lang=js&"
import style0 from "./centerTabs.vue?vue&type=style&index=0&id=ef92941a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef92941a",
  null
  
)

export default component.exports